import { parseDate } from "utils/moment-utils";

export class InquiryValues {
    originalStart: IMoment;
    proposedStart: IMoment;
    originalActivities?: { id: string; name: string }[];
    proposedActivities?: { id: string; name: string }[];

    constructor(values?: InquiryValues) {
        this.originalStart = parseDate(values?.originalStart);
        this.proposedStart = parseDate(values?.proposedStart);
        this.originalActivities = values?.originalActivities;
        this.proposedActivities = values?.proposedActivities;
    }
}
